import React from 'react';
import { Box, Link, Stack, Text } from '@99designs/emu';
import { GridLayout } from '@99designs/marketing-ui';
import { trackEvent } from '@99designs/tracking';
import { TabId } from '../TabsMenu';
import CustomerRating from './CustomerRating';
// Assuming you have a CustomerRating component
import StarRating from './StarRating';

const CustomerRatingsList = () => {
    // Sample data for three customer ratings including comments and avatars
    const ratings = [
        {
            id: 2,
            customerName: 'agsink7N',
            rating: 5,
            comment:
                'Great experience and we ended up with a logo that was exactly as requested, with a hand drawn sketch as the only reference. We had 2 great artists answer our call!',
            customerId: '5530888',
            contestId: '1238135',
            ratingElapsedTime: 'a month ago',
        },
        {
            id: 3,
            customerName: 'bennycatalanov',
            rating: 5,
            comment:
                'Did not expect to receive over 100 designs by the time the competition ended! We were blown away with our experience working with 99designs!',
            customerId: '5420906',
            contestId: '1225487',
            ratingElapsedTime: '4 months ago',
        },
        {
            id: 1,
            customerName: 'caubte',
            rating: 4,
            comment:
                'At first I was disappointed with the designs I was getting but the great customer service they have gave me hope since the best designs are not the first ones, also making the contest “blind” allows designers to be more creative, I ended up loving my design',
            customerId: '5451213',
            contestId: '1227965',
            ratingElapsedTime: '4 months ago',
        },
    ];

    // Hardcoded total rating
    const totalRating = 4.8; // Change this to your desired total rating value

    return (
        <Stack space={['0.5bu', '0.5bu', '1bu', '1bu']}>
            <GridLayout>
                <Box display="flex" flex-direction="row" id={TabId.Reviews}>
                    <Text size="size5" fontFamily="heading">{`${
                        totalRating.toFixed(1) + ' ' + __('stars')
                    }`}</Text>
                    <Box paddingLeft={'0.75bu'} paddingTop={'0.25bu'}>
                        <StarRating rating={5} />
                    </Box>
                </Box>
                {ratings.map((rating) => (
                    <CustomerRating
                        key={rating.contestId}
                        customerName={rating.customerName}
                        rating={rating.rating}
                        comment={rating.comment}
                        customerId={rating.customerId}
                        ratingTime={rating.ratingElapsedTime}
                        contestId={rating.contestId}
                    />
                ))}
                <Box paddingY={'1bu'}>
                    <Link
                        href="/testimonials/logo-design"
                        target="_blank"
                        onClick={() =>
                            trackEvent('Rating CTA clicked on product details page', {
                                path: '/testimonials/logo-design',
                                type: 'seeAllReviews',
                            })
                        }
                    >
                        {__('See All 26066 Customer reviews')}
                    </Link>
                </Box>
            </GridLayout>
        </Stack>
    );
};

export default CustomerRatingsList;
